/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdatePaymentAccountReferenceRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/UpdatePaymentAccountReference.pb'
import {UpdatePaymentAccountReferenceResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/UpdatePaymentAccountReference.pb'


export const updatePaymentAccountReference = (request: UpdatePaymentAccountReferenceRequest, options?: CashRequestOptions) => post<UpdatePaymentAccountReferenceRequest, UpdatePaymentAccountReferenceResponse>("/2.0/cash/update-payment-account-reference", request, {...options, rejectOnError: true })